<div class="profile-container">
    <div class="">
        <div class="profile-content">
            <div class="personal-details">
                <!-- <h4 class="personal-details-title">COMPOSITION</h4> -->
                <div cdkDropListGroup class="composition-block">
                  <div class="example-container-left">
                    <h2>Products</h2>
                
                    <div
                      cdkDropList
                      [cdkDropListData]="cProductList"
                      class="example-list1"
                      (cdkDropListDropped)="drop($event)">
                      <div class="example-box1" *ngFor="let item of cProductList" cdkDrag>{{item.name}}</div>
                    </div>
                  </div>
                
                  <div class="example-container-right">
                    <h2>Product Category</h2>
                    <div class="row">
                      <div class="col-md-6 col-lg-6">
                        <input type="text" placeholder="enter name" [(ngModel)]="name" class="form-control">
                      </div>
                      <div class="col-md-6 col-lg-6">
                        <div class="form-group ">
                            <ng-multiselect-dropdown
                            [placeholder]="'select sub categories'"
                            [settings]="dropdownSettings"
                            [data]="categoryList"
                            [(ngModel)]="selectedCategoryList"
                            class="form-control"
                            style="padding: 0;border: none"
                            (onSelect)="onItemSelect($event)"
                            (onSelectAll)="onSelectAll($event)"
                            >
                            </ng-multiselect-dropdown>
                          </div> 
                      </div>
                      <div class="col-md-6 col-lg-6">
                        <div class="form-group image-b" *ngIf="imageUrl == ''">
                            <button class="" (click)="imageButtonClick()">add category image</button>
                            <input type="file" id="imageInput" (change)="onChange($event)" accept="image/*" [style.display]="'none'">
                        </div>
                        <div class="form-group image-view" *ngIf="imageUrl != ''">
                            <label>Category Image </label>
                            <img [src]="imageUrl" alt="" srcset="">
                            <button class="btn btn-secondary" (click)="imageRemove()">Remove</button>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-6 display-checkbox">
                      <input type="checkbox" [(ngModel)]="isHomePage">
                      <label for="">Display in home page</label>
                    </div>
                      <div class="col-md-12 col-lg-12">
                        <input type="text" placeholder="enter description" class="form-control" [(ngModel)]="description">
                      </div>
                    </div>
               
  
                    <div
                      cdkDropList
                      [cdkDropListData]="done"
                      class="example-list"
                      (cdkDropListDropped)="drop($event)">
                      <div class="example-box" *ngFor="let item of done" cdkDrag>
                        <div class="row input-data">
                          <!-- <div class="col-md-12 col-lg-12">
                            <p>{{item.name}}</p>
                          </div> -->
                          <div class="col-md-6 col-lg-6">
                            <label for="">Name:</label>
                            <p>{{item.name}}</p>
                          </div>
                          <div class="col-md-6 col-lg-6">
                            <label for="">ProductId:</label>
                            <p>{{item.productId}}</p>
                          </div>
                          <div class="col-md-6 col-lg-6">
                            <label for="">Quantity:</label>
                            <p>{{item.quantity}}</p>
                          </div>
                          <div class="col-md-6 col-lg-6">
                            <label for="">Uom:</label>
                            <p>{{item.uom}}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="submit-footer">
                      <div>
                        <button class="add-b" (click)="add()">submit</button>
                      </div>
                    </div>
                  </div>
              </div>
            </div>
  
        </div>
    </div>
  </div>